export const safeArray = <T>(value: unknown, context: string): T[] => {
  if (Array.isArray(value)) return value as T[];

  console.error(`[ResponseValidation] ${context} was not an array. Defaulted to [] to prevent a runtime crash.`, value);
  return [];
};
